angular.module('dnecom')
    .controller('IntegrationFBModalController', ["$scope", "$http", "notifications", "WindowUtils", function($scope, $http, notifications, WindowUtils) {
        var openedWindow;
        window.$scope = $scope;

        if (!$scope.account.pages && $scope.account.properties.page) {
            console.log('IntegrationFBModalController', $scope.account.properties.page);
            $scope.account.pages = [$scope.account.properties.page];
        }

        $scope.authorize = function() {
            $scope.authorizing = true;

            openedWindow = WindowUtils.openBlank('about:blank', {
                width: 860,
                height: 590
            });

            openedWindow.document.write('Waiting for response...');
            openedWindow.document.close();

            $http.post(Routing.generate('api_integrations_facebook_authorize', {
                'id': $scope.account.id
            }), $scope.account)
                .then(function(response) {
                    if (!response.data.success || !response.data.authUrl) {
                        openedWindow.close();
                        notifications.danger(response.data.message || 'Unknown error.');
                        $scope.authorizing = false;
                        return;
                    }

                    openedWindow.location.href = response.data.authUrl;
                    $scope.account.id = response.data.accountId;
                }, function() {
                    openedWindow.close();
                    $scope.authorizing = false;
                    notifications.danger('Request error.');
                });
        };

        $scope.accountAccess = function(name, pages, errors) {
            $scope.account.errors = errors;

            if (!errors.length) {
                $scope.account.properties = {
                    name: name
                };

                if (pages.length) {
                    $scope.setPublicPages(pages);
                }
            }

            $scope.$apply();
            openedWindow.close();
        };

        $scope.changePublicPage = function() {
            const id = $scope.account.properties.page.id

            for (var i in $scope.account.pages) {
                if ($scope.account.pages[i].id === id) {
                    $scope.account.properties.page.name = $scope.account.pages[i].name;
                    break;
                }
            }
        };

        $scope.checkPublicPages = function() {
            $scope.account.errors = [];

            $http.get(Routing.generate('api_integrations_facebook_pages', {
                'id': $scope.account.id
            }), $scope.account)
                .then(function(response) {
                    if (response.data.errors) {
                        $scope.account.errors = response.data.errors;
                        return;
                    }

                    $scope.setPublicPages(response.data.pages);
                }, function() {
                });
        };

        $scope.setPublicPages = function(pages) {
            $scope.account.pages = pages;
            $scope.account.properties.page = {
                id: $scope.account.properties.page ?
                    $scope.account.properties.page.id :
                    $scope.account.pages[0].id,
                name: $scope.account.pages[0].name
            };
        };
    }]);
